/**
 * Onboarding completion stored in Supabase profiles table (onboarding_completed column).
 * Persists across devices so users don't repeat onboarding when switching devices.
 */

import { removeCachedProfile } from '@/lib/profile-cache';
import { supabase } from '@/lib/supabase';

/** Check if the user has completed onboarding. */
export async function getOnboardingCompleted(userId: string): Promise<boolean> {
  if (!supabase) {
    return false;
  }
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('onboarding_completed')
      .eq('id', userId)
      .single();

    if (error || !data) {
      return false;
    }
    return data.onboarding_completed === true;
  } catch (error) {
    console.error('[onboarding-storage] getOnboardingCompleted error:', error);
    return false;
  }
}

/** Mark onboarding as completed for the user. */
export async function setOnboardingCompleted(userId: string): Promise<void> {
  if (!supabase) {
    throw new Error('Supabase is not configured');
  }
  try {
    const { error } = await supabase
      .from('profiles')
      .update({
        onboarding_completed: true,
        updated_at: new Date().toISOString(),
      })
      .eq('id', userId);

    if (error) throw error;
    removeCachedProfile(userId);
  } catch (error) {
    console.error('[onboarding-storage] setOnboardingCompleted error:', error);
    throw error;
  }
}
